<script>
export default {
    name: 'IconGroup',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-group"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 28c8.955 0 16.536 5.886 19.084 14C48.536 50.113 40.955 56 32 56s-16.536-5.886-19.085-14c2.55-8.114 10.13-14 19.085-14zm-14.5-2c1.88 0 3.638.523 5.138 1.433-5.761 2.146-8.262 6.386-11.156 10.532A10.005 10.005 0 018 33c1.268-4.057 5.042-7 9.5-7zm29 0c4.458 0 8.231 2.943 9.5 7a10.015 10.015 0 01-3.278 4.807c-2.338-3.94-5.327-8.198-11.375-10.364A9.869 9.869 0 0146.5 26zM32 8a8 8 0 110 16 8 8 0 010-16zm14.5 8c2.2 0 3.982 1.79 3.982 4S48.7 24 46.5 24s-3.982-1.79-3.982-4 1.783-4 3.982-4zm-29 0c2.2 0 3.982 1.79 3.982 4S19.7 24 17.5 24s-3.982-1.79-3.982-4 1.783-4 3.982-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
